// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoCardPlaceholder__container-f84c96 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 16px;
}

.InfoCardPlaceholder__content-f2696e {
  margin-inline-start: 12px;
}

.InfoCardPlaceholder__content-f2696e .InfoCardPlaceholder__first-line-bed743 {
  margin-bottom: 4px;
  display: block;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Placeholders/InfoCardPlaceholder/InfoCardPlaceholder.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 16px;\n}\n\n.content {\n  margin-inline-start: 12px;\n}\n\n.content .first-line {\n  margin-bottom: 4px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `InfoCardPlaceholder__container-f84c96`,
	"content": `InfoCardPlaceholder__content-f2696e`,
	"first-line": `InfoCardPlaceholder__first-line-bed743`,
	"firstLine": `InfoCardPlaceholder__first-line-bed743`
};
module.exports = ___CSS_LOADER_EXPORT___;
